var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.scrollbarTag,{key:_vm.$vs.rtl,ref:"scrollArea",tag:"component",staticClass:"vx-scroll-area",class:{ 'no-scroll-x': _vm.preventScrollX },attrs:{"settings":_vm.settings}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }